/* import __COLOCATED_TEMPLATE__ from './report-list-item.hbs'; */
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { Report } from '../../models/report';
import { task, timeout } from 'ember-concurrency';
import { absoluteStoryhunterUrl } from "../../utils/url";

const CLASS_NAME = 'SH-c-admin-reports__report-list-item';

export default Component.extend({
  tagName: '',
  CLASS_NAME,

  api: service(),
  applicationStateManager: service('state-managers/application'),

  /** @param {Report} */
  report: null,

  showAbsoluteTime: false,

  momentCalendarOptions: {
    sameDay: '[Today at] h:mma',
    nextDay: '[Tomorrow at] h:mma',
    lastDay: '[Yesterday at] h:mma',
    lastWeek: '[Last] dddd [at] h:mma',
    sameElse: 'D MMM YYYY [at] h:mma',
  },

  /**
   * Re-run the given report, then poll until it is either updated or we have timed out
   */
  handleRefresh: task(function *() {
    const currentUpdatedAt = this.get('report.updatedAt');

    // Re-run the report (async)
    yield this.get('api').put(
      `reports/${this.get('report.id')}/refresh`,
    );

    // Wait until the report has been updated
    let attempts = 0;
    while(true) {
      yield this.get('report').reload();

      // See if the report updated time has changed
      if (currentUpdatedAt.getTime() < this.get('report.updatedAt').getTime()) {
        break;
      }

      attempts++;

      // Timeout after ~30 seconds (plus the time of the api calls)
      if (attempts >= 30) {
        this.get('applicationStateManager').addToast('Failed to refresh');
        break;
      }

      yield timeout(1000);
    }
  }),

  /** @inheritDoc */
  actions: {
    handleDownload() {
      window.open(absoluteStoryhunterUrl(`/reports/${this.get('report.id')}/download`));
    },

    handleRefresh() {
      this.get('handleRefresh').perform();
    },

    toggleShowAbsoluteTime() {
      this.toggleProperty('showAbsoluteTime');
    },
  },
});
